import { STORE_SITE, STORE_SITE_ERROR, LOADING_SITE } from './types'

export function storeSite(site) {
    return {
        type: STORE_SITE,
        payload: site
    }
}
export function loadingSite() {
    return {
        type: LOADING_SITE
    }
}
export function storeSiteError(error) {
    return {
        type: STORE_SITE_ERROR,
        payload: error
    }
}